import type { CoursePriceCurrency } from './coursePriceCurrency';

/**
 * 코스 가격 정보
 */
export interface CoursePrice {
  /**
   * 가격 (0은 무료)
   * @minimum 0
   */
  amount: number;
  /** 통화 코드 */
  currency: CoursePriceCurrency;
}
